import { useEffect, useState } from "react"
import { useParams } from "react-router"
import { api_getBatterPersonPageData } from "../API/wrappedAPIs"
import { ZoneChart, ZoneChart2 } from "../Components/Charts/ZoneChart"
import { PRChart } from "../Components/Charts/PRChart"
import Footer from "../Components/Footer"
import Header from "../Components/Header"
import { GraphFrame, PersonTable, SubTableFrame, PlayByPlayFrame, EmptyFrame, WhiteBkgGraphFrame, wrapBallCountTitleWithLight, PersonalProfileFrame, BattedHeatMap, AdditionalHeader, FullLengthGraphFrame } from "../Components/PersonFrame"
import { wrapBatterPersonPageData } from "../Utils/PersonalDataProcess"
import { PlayerIDMap, PlayerMap, TeamNameMap } from "../Utils/PlayerMaps"
import { BarrelChart, BubbleChart } from "../Components/Charts/BubbleChart"
import { ev_la_config } from "../Components/Charts/configs/ev_la_config"
import Loading from "../Components/Loading"
import { BallCountFrame, ZoneAreaBreakdownFrame } from "../Components/IntegratedBCountFrame"
import { FormProvider, useForm } from "react-hook-form"
import { MultiSelectionBox } from "../Components/InputBox"
import { TaggedPitchTypeLabelMap } from "../Utils/FilterValueMap"
import { BatterScoreLogsTrendOptions, hpos_config, IntegrateKZoneConfig2, KZoneConfig2, PitchPortionConfig } from "../Components/Charts/configs/person_configs"
import { wrapBatHeatMapData, wrapBatterScoreLogTrendData, wrapPieChartDataWithConditions, wrapPointDataWithConditions, wrapZoneAreaBreakdownData } from "../Utils/PersonChartDataProcess"
import { PieChart } from "../Components/Charts/PieChart"
import { ballColorMap, ballTypeColorMap } from "../Utils/ColorMap"
import { LineChart } from "../Components/Charts/LineChart"

const Tabs = ({tags, current, setCurrent}) => {
  let tabs = []
  for (const e in tags) {
    let tab_classname = e === current ? 'tabr' : 'tab'
    let arrow_classname = e === current ? 'tab_arrowr' : 'tab_arrow'
    tabs.push(
      <div className='tab_block' id={e} onClick={(e) => { setCurrent(e.target.id) }}>
        <div className={tab_classname} id={e}>{tags[e]}</div>
        <div className={arrow_classname} />
      </div>
    )
  }
  return tabs
}

let initData = {
  ystat: [],
  stats: [],
  stdstat: [],
  chart: {
    evZoneGraph: undefined,
    laZoneGraph: undefined,
    avgLZoneGraph: undefined,
    avgRZoneGraph: undefined,
    prGraph: {},
    evlaGraph: {
      ev: [],
      la: [],
    }
  },
  hlocdata: {datasets: []},
  htmpdata: {},
}

const bcounts_map = ['0-0', '0-1', '0-2', '1-0', '1-1', '1-2', '2-0', '2-1', '2-2', '3-0', '3-1', '3-2']
const bcounts_tag_map = {
  '0-0': wrapBallCountTitleWithLight('0S0B', true),
  '0-1': wrapBallCountTitleWithLight('1S0B', true),
  '0-2': wrapBallCountTitleWithLight('2S0B', true),
  '1-0': wrapBallCountTitleWithLight('0S1B', true),
  '1-1': wrapBallCountTitleWithLight('1S1B', true), 
  '1-2': wrapBallCountTitleWithLight('2S1B', true), 
  '2-0': wrapBallCountTitleWithLight('0S2B', true), 
  '2-1': wrapBallCountTitleWithLight('1S2B', true), 
  '2-2': wrapBallCountTitleWithLight('2S2B', true), 
  '3-0': wrapBallCountTitleWithLight('0S3B', true), 
  '3-1': wrapBallCountTitleWithLight('1S3B', true),
  '3-2': wrapBallCountTitleWithLight('2S3B', true)
}

const PersonBatter = () => {
  const [data, setData] = useState(initData)
  const [page, setPage] = useState('statistics')
  const [current, setCurrent] = useState("statistics")
  const [loading, setLoading] = useState(false)
  const [side, setSide] = useState('all')
  const [sitSide, setSitSide] = useState('all')
  const [kSide, setKSide] = useState('all')
  const [hmap, setHMap] = useState([])
  const { team, number } = useParams()
  const tags = {
    "statistics": {
      "statistics": "數據分析圖表", "playbyplay": "逐打席逐球數據"
    },
    "integrate-ball-count": {
      "integrate-ball-count": '整合球數狀況',
    }, 
    "zones": {
      "zones": '好球帶熱區分佈',
    },
    "situation-break-down": {
      "situation-break-down": '球數攻擊偏好',
    },
    "graphical-data": {
      "graphical-data": '綜合圖表分析'
    }
  }
  const pages = ["statistics", "integrate-ball-count", "zones", "situation-break-down", "graphical-data"]
  const pageMap = {
    "statistics": "數據分析圖表",
    "integrate-ball-count": '整合球數狀況',
    "zones": '好球帶熱區分佈',
    "situation-break-down": '球數攻擊偏好',
    "graphical-data": '綜合圖表分析'
  }
  const form = useForm()

  useEffect(() => {
    setLoading(true)
    api_getBatterPersonPageData(PlayerMap[team][number], PlayerIDMap[team][number]).then((res) => {
      // console.log(res)
      let pdata = wrapBatterPersonPageData(res[0].data, res[1].data, res[2].data, res[3].data, res[4].data)
      setData(pdata)
      // console.log(pdata)
      setHMap(wrapBatHeatMapData(pdata.htmpdata))
      setLoading(false)
      form.setValue('ibc-selected-tag', pdata.ibcdata.pitchTypeSet)
      form.setValue('sbd-pitch-type', pdata.sitdata.ptSet)
    })
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    setCurrent(page)
  }, [page])

  const tableHeaders = {
    ystat: ['Year', 'G', 'PA', 'AB', 'RBI', 'R', 'H', 'HR', 'AVG', 'OBP', 'SLG', 'OPS'],
    stats: ['Swing%','Z-Swing%','O-Swing%','Z-Contact%','Whiff%','Weak','Top','Under','Flare-Burner','Solid','Barrel'],
    stdstat: ['Year', 'G', 'AB', 'PA', 'H', '1B', '2B', '3B', 'HR', 'R', 'RBI', 'BB', 'IBB', 'K', 'HBP', 'SF', 'SH', 'DP', 'SB', 'CS', 'AVG']
  }

  const overallTables = [
    <PersonTable sheet={{headers: tableHeaders.ystat, data: data.ystat}} leftTitle />,
    <PersonTable sheet={{headers:tableHeaders.stats, data: [{data: data.stats}]}} />
  ]

  const stdTable = [
    <PersonTable sheet={{headers: tableHeaders.stdstat, data: data.stdstat}} leftTitle />
  ]

  const evlaChartData = {
    datasets: [
      {   //velo   
        label: "E_Velo",
        pointBackgroundColor: "#0080FF",
        borderWidth: 1,
        borderColor: "#000000",
        data: data.chart.evlaGraph.ev,

      },
      {   //angle   
        label: "E_Angle",
        pointBackgroundColor: "#ff0000",
        borderWidth: 1,
        borderColor: "#000000",
        data: data.chart.evlaGraph.la,

      }
    ],
  }

  const PageContent = ({currentTag}) => {
    const tag_map = { 'left': '左投', 'right': '右投', 'all': '全部'}
    switch (currentTag) {
      case 'statistics':
        return (
          <>
            <SubTableFrame title={'總覽'} tables={overallTables} />
            <SubTableFrame title={'一般數據'} tables={stdTable} />
            <div className="htmp-block">
              {hmap.slice(0, 4).map((p) => (<BattedHeatMap title={p.title} data={p} />))}
            </div>
            <div className="htmp-block">
              {hmap.slice(4, 8).map((p) => (<BattedHeatMap title={p.title} data={p} />))}
            </div>
            <div className="htmp-block">
              {hmap.slice(8, 12).map((p) => (<BattedHeatMap title={p.title} data={p} />))}
            </div>
            <GraphFrame title={'指標數據PR'} graph={<PRChart chartdata={data.chart.prGraph} />} classname={'chart_pr'} />
            {/*<GraphFrame title={'Zone - 仰角'} graph={<ZoneChart title="Avg Launch Angle" type='la' zone={data.chart.laZoneGraph} />} />*/}
            {/*<GraphFrame title={'Zone - 初速'} graph={<ZoneChart title="Avg Exit Velocity" type='ev' zone={data.chart.evZoneGraph} />} />*/}
            <GraphFrame title={'Zone - AvgR'} graph={<ZoneChart title="AVG - RHP" type='avgR' zone={data.chart.avgRZoneGraph} />} />
            <GraphFrame title={'Zone - AvgL'} graph={<ZoneChart title="AVG - LHP" type='avgL' zone={data.chart.avgLZoneGraph} />} />
            <GraphFrame title={'擊球結果圖'} graph={<BarrelChart data={data.chart.barrelGraph} />} />
            <GraphFrame title={'逐球擊球初速 / 擊球仰角'} graph={<BubbleChart data={evlaChartData} config={ev_la_config} />} colClass='col3_2' />
          </>
        )
      case 'playbyplay':
        return data.pbp === undefined || Object.keys(data.pbp)[0] === undefined? <EmptyFrame />:<PlayByPlayFrame type="batter" data={data.pbp} />
      case 'integrate-ball-count':
        return (
          data.ibcdata === undefined ? <EmptyFrame /> :
            <div className="ibc-body">
              <div className="ibc-select">
                <select value={side} onChange={(evt) => (setSide(evt.target.value))}>
                  {['all', 'right', 'left'].map((e) => (<option value={e}>{tag_map[e]}</option>))}
                </select>
                <MultiSelectionBox name='ibc-selected-tag' options={data.ibcdata.pitchTypeSet} optionTagMap={TaggedPitchTypeLabelMap} />
              </div>
              <div className="ibc-frames">
                <BallCountFrame title={wrapBallCountTitleWithLight('0S0B')} data={{ zone: data.ibcdata.zone[side]['0-0'], usage: data.ibcdata.usage[side]['0-0'] }} selected={form.watch('ibc-selected-tag')} />
                <BallCountFrame title={wrapBallCountTitleWithLight('1S0B')} data={{ zone: data.ibcdata.zone[side]['1-0'], usage: data.ibcdata.usage[side]['1-0'] }} selected={form.watch('ibc-selected-tag')} />
                <BallCountFrame title={wrapBallCountTitleWithLight('2S0B')} data={{ zone: data.ibcdata.zone[side]['2-0'], usage: data.ibcdata.usage[side]['2-0'] }} selected={form.watch('ibc-selected-tag')} />
                <BallCountFrame title={wrapBallCountTitleWithLight('0S1B')} data={{ zone: data.ibcdata.zone[side]['0-1'], usage: data.ibcdata.usage[side]['0-1'] }} selected={form.watch('ibc-selected-tag')} />
                <BallCountFrame title={wrapBallCountTitleWithLight('1S1B')} data={{ zone: data.ibcdata.zone[side]['1-1'], usage: data.ibcdata.usage[side]['1-1'] }} selected={form.watch('ibc-selected-tag')} />
                <BallCountFrame title={wrapBallCountTitleWithLight('2S1B')} data={{ zone: data.ibcdata.zone[side]['2-1'], usage: data.ibcdata.usage[side]['2-1'] }} selected={form.watch('ibc-selected-tag')} />
                <BallCountFrame title={wrapBallCountTitleWithLight('0S2B')} data={{ zone: data.ibcdata.zone[side]['0-2'], usage: data.ibcdata.usage[side]['0-2'] }} selected={form.watch('ibc-selected-tag')} />
                <BallCountFrame title={wrapBallCountTitleWithLight('1S2B')} data={{ zone: data.ibcdata.zone[side]['1-2'], usage: data.ibcdata.usage[side]['1-2'] }} selected={form.watch('ibc-selected-tag')} />
                <BallCountFrame title={wrapBallCountTitleWithLight('2S2B')} data={{ zone: data.ibcdata.zone[side]['2-2'], usage: data.ibcdata.usage[side]['2-2'] }} selected={form.watch('ibc-selected-tag')} />
                <BallCountFrame title={wrapBallCountTitleWithLight('0S3B')} data={{ zone: data.ibcdata.zone[side]['0-3'], usage: data.ibcdata.usage[side]['0-3'] }} selected={form.watch('ibc-selected-tag')} />
                <BallCountFrame title={wrapBallCountTitleWithLight('1S3B')} data={{ zone: data.ibcdata.zone[side]['1-3'], usage: data.ibcdata.usage[side]['1-3'] }} selected={form.watch('ibc-selected-tag')} />
                <BallCountFrame title={wrapBallCountTitleWithLight('2S3B')} data={{ zone: data.ibcdata.zone[side]['2-3'], usage: data.ibcdata.usage[side]['2-3'] }} selected={form.watch('ibc-selected-tag')} />
              </div>
            </div>
        )
      case 'zones':
        return (
          <>
            <div className="sbd-select zone-select">
              <select value={kSide} onChange={(evt) => (setKSide(evt.target.value))}>
                {['all', 'right', 'left'].map((e) => (<option value={e}>{tag_map[e]}</option>))}
              </select>
            </div>
            <WhiteBkgGraphFrame graph={<ZoneChart2 title="Pitch%" type='batter_pitch_pct' zone={data.zones[kSide].pitch} percentage nullValue={'0%'} />} />
            <WhiteBkgGraphFrame graph={<ZoneChart2 title="Swing%" type='batter_swing_pct' zone={data.zones[kSide].swing} percentage nullValue={'0%'} />} />
            <WhiteBkgGraphFrame graph={<ZoneChart2 title="Whiff%" type='batter_whiff' zone={data.zones[kSide].whiff} percentage nullValue={'0%'} />} />
            <WhiteBkgGraphFrame graph={<ZoneChart2 title="K%" type='batter_kp' zone={data.zones[kSide].k} percentage nullValue={'0%'} />} />
            <WhiteBkgGraphFrame graph={<ZoneChart2 title="Hits" type='batter_hit' zone={data.zones[kSide].h} />} />
            <WhiteBkgGraphFrame graph={<ZoneChart2 title="Homeruns" type='batter_hr' zone={data.zones[kSide].hr} />} />
            <WhiteBkgGraphFrame graph={<ZoneChart2 title="Singles" type='batter_single' zone={data.zones[kSide].single} />} />
            <WhiteBkgGraphFrame graph={<ZoneChart2 title="Doubles" type='batter_double' zone={data.zones[kSide].double} />} />
            <WhiteBkgGraphFrame graph={<ZoneChart2 title="Triples" type='batter_triple' zone={data.zones[kSide].triple} />} />
            <WhiteBkgGraphFrame graph={<ZoneChart2 title="Ground Ball%" type='batter_ground' zone={data.zones[kSide].ground} percentage nullValue={'0%'} />} />
            <WhiteBkgGraphFrame graph={<ZoneChart2 title="Line Drive%" type='batter_line' zone={data.zones[kSide].line} percentage nullValue={'0%'} />} />
            <WhiteBkgGraphFrame graph={<ZoneChart2 title="Fly Ball%" type='batter_fly' zone={data.zones[kSide].fly} percentage nullValue={'0%'} />} />
            <WhiteBkgGraphFrame graph={<ZoneChart2 title="Pop-up%" type='batter_pop' zone={data.zones[kSide].pop} percentage nullValue={'0%'} />} />
            <WhiteBkgGraphFrame graph={<ZoneChart title="Batting Average" type='bavg' zone={data.zones[kSide].avg} />} />
            <WhiteBkgGraphFrame graph={<ZoneChart title="Slugging% (SLG)" type='bslg' zone={data.zones[kSide].slg} />} />
            <WhiteBkgGraphFrame graph={<ZoneChart title="Isolated Power (ISO)" type='biso' zone={data.zones[kSide].iso} />} />
            <WhiteBkgGraphFrame graph={<ZoneChart title="wOBA" type='bwoba' zone={data.zones[kSide].woba} />} />
          </>
        )
      case 'situation-break-down':
        return (
          data.sitdata === undefined || data.zabdata === undefined ? <EmptyFrame /> :
            <>
              <div className="sbd-body">
                <div className="sbd-select">
                  <select value={sitSide} onChange={(evt) => (setSitSide(evt.target.value))}>
                    {['all', 'right', 'left'].map((e) => (<option value={e}>{tag_map[e]}</option>))}
                  </select>
                  <span className="select-title">球數</span>
                  <MultiSelectionBox name='sbd-bcount' options={bcounts_map} long />
                  <span className="select-title">球種</span>
                  <MultiSelectionBox name='sbd-pitch-type' options={data.sitdata.ptSet} optionTagMap={TaggedPitchTypeLabelMap} />
                </div>
                <div className="sbd-frames">
                  <WhiteBkgGraphFrame title='Swing Strike' graph={<BubbleChart data={wrapPointDataWithConditions(data.sitdata.whiff, 'pside', sitSide, form.watch('sbd-pitch-type'), form.watch('sbd-bcount'))} config={IntegrateKZoneConfig2} />} />
                  <WhiteBkgGraphFrame title='Called Strike' graph={<BubbleChart data={wrapPointDataWithConditions(data.sitdata.watch, 'pside', sitSide, form.watch('sbd-pitch-type'), form.watch('sbd-bcount'))} config={IntegrateKZoneConfig2} />} />
                  <WhiteBkgGraphFrame title='In-Play' graph={<BubbleChart data={wrapPointDataWithConditions(data.sitdata.inplay, 'pside', sitSide, form.watch('sbd-pitch-type'), form.watch('sbd-bcount'))} config={IntegrateKZoneConfig2} />} />
                </div>
                <div className="sbd-charts">
                  <div className="sbd-pie">
                    <div className="sbd-pie-title">球種比例分佈</div>
                    <PieChart data={wrapPieChartDataWithConditions([...data.sitdata.whiff, ...data.sitdata.watch, ...data.sitdata.inplay], 'pside', sitSide, form.watch('sbd-pitch-type'), form.watch('sbd-bcount'), 'batter', ballTypeColorMap)} config={PitchPortionConfig} />
                  </div>
                  <ZoneAreaBreakdownFrame data={wrapZoneAreaBreakdownData(data.zabdata, 'pside', sitSide, form.watch('sbd-pitch-type'), form.watch('sbd-bcount'), 'batter', ballTypeColorMap)} />
                </div>
              </div>
            </>
        )
      case 'graphical-data':
        return (
          data.scorelogdata === undefined || data.scorelogdata.len === 0 ? <EmptyFrame /> :
            <>
              <FullLengthGraphFrame graph={<LineChart config={{options: BatterScoreLogsTrendOptions}} data={wrapBatterScoreLogTrendData(data.scorelogdata[0])} />} />
              <FullLengthGraphFrame graph={<LineChart config={{options: BatterScoreLogsTrendOptions}} data={wrapBatterScoreLogTrendData(data.scorelogdata[1])} />} />
            </>
        )
    }
  }

  return (
    <FormProvider {...form}>
      <Loading visible={loading} />
      <Header />
      <AdditionalHeader name={PlayerMap[team][number]} titles={pages} titleMap={pageMap} current={page} changePage={setPage} />
      <div className="wrapper">
        <div className="wrap setin">
          <div className="person_score">
            <div className="title_frame">
              <div className="breadcrumbs2">{TeamNameMap[team]} {number}</div>
              <div className="title">{PlayerMap[team][number]}</div>
            </div>
            <div className="page">
              <div className="page_content">
                <PersonalProfileFrame team={team} number={number} />
                <GraphFrame title={'指標數據PR'} graph={<PRChart chartdata={data.chart.prGraph} />} classname={'chart_pr'} colClass={'col3_p'} frameClass='tab_content3' />
                <GraphFrame title={'擊球位置分佈'} graph={<BubbleChart data={data.hlocdata} config={hpos_config} />} colClass={'col3_p'} frameClass={'tab_content3'} />
                <div className="player_sep_title"><span>Stats</span></div>
                <PersonTable tableClass="player_stats" sheet={{headers: tableHeaders.stdstat, data: data.stdstat}} leftTitle />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="wrapper pp_bg_gray">
        <div className='wrap setin'>
          <div className='lb_page_tab_frame'>
            <Tabs tags={tags[page]} current={current} setCurrent={setCurrent} />
          </div>
          <div className='page'>
            <div className="page_content tab_table">
              <PageContent currentTag={current} />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </FormProvider>
  )
}

export default PersonBatter